<script>
import ProfilePicture from "@/components/_Shared/Profile/Picture";
import SelectState from "@/components/_Shared/IBGE/States";
import SelectCity from "@/components/_Shared/IBGE/Cities";
import StepText from "@/components/SignUp/Steps/StepText";

import errorMixin from "@/mixins/errorMixin";
import { mapActions, mapState } from "vuex";

export default {
  mixins: [errorMixin],
  data() {
    return {
      profile_picture: "",
      city: 0,
      state: 0,
      birthdate: "",
      phone: "",
      stateError: false,
      cityError: false
    };
  },

  components: {
    ProfilePicture,
    SelectState,
    SelectCity,
    StepText
  },

  computed: {
    ...mapState("signUp", [
      "profile",
      "phones",
      "fieldErrors",
      "displayIBGESelects"
    ])
  },

  methods: {
    ...mapActions("signUp", [
      "prevStep",
      "nextStep",
      "setProfile",
      "setPhones",
      "hideIBGESelects"
    ]),

    async submit() {
      try {
        await this.validate();
        this.nextStep();
      } catch (e) {
        this.$toasted.error(e);
      }
    },

    store() {
      const { profile_picture, city, state, birthdate, phone } = this.$data;

      const profile = {
        profile_picture,
        city,
        state,
        birthdate
      };

      const phones = [phone];

      this.setProfile(profile);
      this.setPhones(phones);
    },

    getPicture(picture) {
      this.profile_picture = picture;
    },

    async validate() {
      let dataIsValid = await this.$validator.validateAll();
      this.stateError = !this.state;
      this.cityError = this.state && !this.city;
      if (!dataIsValid || this.stateError || this.cityError)
        throw "Existem dados incorretos ou incompletos!";
    }
  },

  mounted() {
    document.querySelector("input:not([type='file'])").focus();
    this.inputErrors(this.fieldErrors);
    if (this.profile) Object.assign(this.$data, this.profile);
    if (this.phones.length) this.phone = this.phones[0];
  },

  watch: {
    state(val) {
      if (val) this.stateError = false;
    },
    city(val) {
      if (val) this.cityError = false;
    },
    displayIBGESelects(val) {
      if (!val) {
        this.city = "";
        this.state = "";
      }
    }
  },

  beforeDestroy() {
    this.store();
  }
};
</script>

<template>
  <form @submit.prevent="submit()">
    <base-flex class="mt-10" direction="column">
      <profile-picture v-model="profile_picture" :value="profile_picture" />
      <step-text>Agora precisamos que você informe os dados do seu perfil. Ahh, e adicione uma foto clicando acima :)</step-text>
    </base-flex>

    <base-input
      :error="errors.first('birthdate')"
      :masked="true"
      v-validate="'required|date_format:DD/MM/YYYY'"
      v-model="birthdate"
      label="Data de nascimento"
      name="birthdate"
      data-vv-as="Data de nascimento"
      mask="##/##/####"
    />

    <base-input
      :error="errors.first('Celular')"
      :mask="['(##) ####-####', '(##) #####-####']"
      v-validate="'required|numeric|min:10|max:11'"
      v-model="phone"
      label="Celular"
    />

    <template v-if="displayIBGESelects">
      <select-state v-model="state" :value="state" :error="stateError" @error="hideIBGESelects()" />
      <select-city
        v-model="city"
        :value="city"
        :error="cityError"
        :state="state"
        @error="hideIBGESelects()"
      />
    </template>

    <template v-else>
      <base-input
        :error="errors.first('UF')"
        v-validate="'required|length:2'"
        v-model="state"
        label="UF"
      />
      <base-input
        :error="errors.first('Cidade')"
        v-validate="'required|min:2|max:255'"
        v-model="city"
        label="Cidade"
      />
    </template>

    <base-flex justify="end" class="mt-10">
      <base-button @click="prevStep()" outlined>voltar</base-button>
      <base-button type="submit">continuar</base-button>
    </base-flex>
  </form>
</template>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Profile.vue